import Lottie from 'lottie-react';
import tenantPuzzle from '../configs/tenant/puzzle.json';
import { useResponsive } from 'v3/common/hooks/useResponsive';
import _ from 'lodash';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import { getData } from '../configs';

const locale = ApplicationDomainUtility.locale;

const Puzzle = () => {
  const { partnerName, isB2b } = ApplicationDomainUtility;
  const isMobile = useResponsive();
  const partnerLable = _.capitalize(partnerName) || 'QuantMan';
  const puzzleLottie = isB2b ? tenantPuzzle : getData(locale, 'puzzle');
  return (
    <div className="row strategy-tools__card">
      <div className="card card-green">
        <h3>TradingView Integration</h3>
        <p>
          Connect your TradingView strategies to {partnerLable} for seamless execution. Combine advanced chart
          analysis from TradingView with {partnerLable}’s automation to enhance your algorithmic trading
          performance.
        </p>

        <ul>
          <li>Link TradingView alerts to {partnerLable}</li>
          <li>Execute trades automatically from charts</li>
          <li>Combine technical insights with automation</li>
        </ul>
        {!isMobile && <Lottie animationData={puzzleLottie} loop className="puzzle-lottie" />}
      </div>
    </div>
  );
};

export default Puzzle;
